var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarehouse = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 125 125",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ccc",
    d: "M74.887 3.35 5.105 39.072V53.61l7.721.103v52.062h123.6l-.065-52.164h8.308V39.075L74.886 3.353l.001-.003Zm47.773 88.675H26.577V45.719l48.311-24.921 47.768 24.921v46.306h.004ZM52.042 57.888h45.273V45.384H52.042v12.504Zm0 22.488h45.07V67.872h-45.07v12.504Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarehouse);
export default ForwardRef;